(() => {
  const scrollToReviews = (event) => {
    const anchor = event.target.closest('[data-dt-review-anchor]');
    if (!anchor) return;

    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) return;

    event.preventDefault();
    reviews.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    window.history.replaceState(null, '', anchor.getAttribute('href'));

    window.Shopify?.analytics?.publish?.('review_summary_clicked', {
      product_id: anchor.dataset.productId,
      product_handle: anchor.dataset.productHandle
    });
  };

  document.addEventListener('click', scrollToReviews);
})();
